/**
 * Stripe.js initialization — publishable-key fetch status + the
 * loadStripe() promise that the Elements provider needs.
 */
class StripeStore {
  #listeners = new Set();

  #stripePromise = null;
  #stripeKeyLoading = false;
  #stripeKeyError = null;

  get stripePromise() { return this.#stripePromise; }
  set stripePromise(v) { this.#stripePromise = v; this.#notify(); }

  get stripeKeyLoading() { return this.#stripeKeyLoading; }
  set stripeKeyLoading(v) { this.#stripeKeyLoading = !!v; this.#notify(); }

  get stripeKeyError() { return this.#stripeKeyError; }
  set stripeKeyError(v) { this.#stripeKeyError = v; this.#notify(); }

  subscribe(listener) {
    this.#listeners.add(listener);
    return () => this.#listeners.delete(listener);
  }

  #notify() { this.#listeners.forEach((l) => l()); }

  clear() {
    this.#stripePromise = null;
    this.#stripeKeyLoading = false;
    this.#stripeKeyError = null;
    this.#notify();
  }
}

const stripeStore = new StripeStore();
export default stripeStore;
